type PendingHandler = (href: string) => void

let handler: PendingHandler | null = null

/** NavigationSkeletonGate kaydı — test/SSR’de no-op. */
export function registerNavigationPendingHandler(next: PendingHandler | null) {
  handler = next
}

/** Link dışı navigasyon (router.push) için skeleton tetikle. */
export function beginRouteTransition(href: string) {
  if (!href || typeof window === 'undefined') return
  handler?.(href)
}
